/**
 * Hook useDebounce
 * 
 * Retarda a execução de uma função até que um determinado tempo
 * tenha passado desde a última vez que foi invocada.
 * 
 * Útil para: busca em tempo real, validações, etc.
 */

import { useState, useEffect } from 'react';

/**
 * @param {*} value - Valor a ser debounced
 * @param {number} delay - Delay em milissegundos (padrão: 500ms)
 * @returns {*} Valor debounced
 */
export const useDebounce = (value, delay = 500) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    // Cria um timer que atualiza o valor após o delay
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    // Limpa o timer se o valor mudar antes do delay
    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};

export default useDebounce;

